







import { Component, Vue } from 'vue-property-decorator'
import SystemConstants from '@/constants/SystemConstants'

@Component
export default class FooterComponent extends Vue {
  /**
   * Copyrightの年を取得する
   */
  get years() {
    const startYear = SystemConstants.COPYRIGHT_START_YEAR
    /* 現在日時を日本時間にずらす */
    const now = new Date()
    now.setTime(now.getTime() + 1000 * 60 * 60 * 9)
    const nowYear = now.getFullYear()
    return startYear.toString() + (startYear === nowYear ? "" : " - " + nowYear.toString())
  }

  /**
   * Copyrightを取得する
   */
  get copyright() {
    return this.years + " " + SystemConstants.COPYRIGHT_NAME
  }
}
